import Box from '@mui/material/Box';
import type { CSSProperties, ReactNode } from 'react';
import type { SlateEditor, TText } from 'platejs';
import { pipeRenderLeaf } from 'platejs/react';
import { useSelected } from 'slate-react';

interface IEmptyLeafProps {
    attributes: {
        className?: string;
        'data-slate-leaf'?: true;
        style?: CSSProperties;
    };
    children: ReactNode;
    leaf: TText;
    readOnly?: boolean;
}

const EmptyLeaf = ({
    attributes,
    children,
    leaf,
    readOnly,
}: IEmptyLeafProps) => {
    const selected = useSelected();

    if (leaf.text !== '' || readOnly) {
        return <span {...attributes}>{children}</span>;
    }

    return (
        <span {...attributes}>
            <Box
                component="span"
                sx={{
                    position: 'relative',
                    width: 32,
                    display: 'inline-block',
                    cursor: 'text',
                    '&::after': {
                        content: '"¶"',
                        position: 'absolute',
                        top: 0,
                        opacity: selected ? 0 : 0.2,
                    },
                }}
            >
                {children}
            </Box>
        </span>
    );
};

/** Empty-line pilcrow; hidden while the cursor is in that block. */
export const createEmptyLeafRenderer = (
    editor: Partial<SlateEditor> | null,
    readOnly?: boolean
) =>
    pipeRenderLeaf(editor as SlateEditor, (props) => (
        <EmptyLeaf {...props} readOnly={readOnly} />
    ));
